import React from 'react'
import ptBRLocale from 'date-fns/locale/pt-BR'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'

type Props = { children: React.ReactNode }

function DateProvider({ children }: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptBRLocale}>
      {children}
    </LocalizationProvider>
  )
}

export default DateProvider
